/* External */
import { memo } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

/* Components */
import OrderedList from '../../../components/OrderedList';

/* Utils */
import { WEB_URL_TO_DISPLAY } from '../../../utils/constants';

const urlEnvironment = WEB_URL_TO_DISPLAY;

const values = {
  span: (chunks) => (
    <span className="dtv-html5-c-pin-login__url">{chunks}</span>
  ),
  url: urlEnvironment,
};

function Steps({ className = 'dtv-html5-c-pin-login__steps', isCreateAccountActive = false }) {
  return isCreateAccountActive ? (
    <p className="dtv-html5-c-pin-login-flow-create-account__content-description">
      <FormattedMessage
        id="pinLogin.flowCreateAccount.pinNumber.text"
        values={values}
      />
    </p>
  ) : (
    <OrderedList className={className} centered>
      <FormattedMessage
        id="pinLogin.pinNumber.firstStep"
        values={values}
      />
      <FormattedMessage id="pinLogin.pinNumber.secondStep" />
    </OrderedList>
  );
}

Steps.propTypes = {
  className: PropTypes.string,
  isCreateAccountActive: PropTypes.bool,
};

export default memo(Steps);
